/**
 * 第三方账户换绑手机号授权登录页面
 * */

import React, { Fragment, PureComponent } from 'react';
import { Modal } from 'antd';
import qs from 'qs';
import Util from '../../script/util';

export default class ChangeBindPhoneAuth extends PureComponent {
  state = {
    wx_visible: false, // 展示用户中心的微信二维码
    wx_url: null, // 用户中心的微信链接地址
    qq_visible: false,
    qq_url: null,
  };

  // QQ 苇渡换绑手机号
  QQSecondaryModal = () => {
    const { base } = this.props;
    const { rootConfig } = base;
    const search = {
      v: rootConfig.version,
      ty: 'unbindphone',
      origin: 2,
    };
    const callbackURI = `${window.location.protocol}//${window.location.host}/loginCallback.html?${qs.stringify(search)}`;
    const param = {
      display: '',
      callbackURI,
      companyId: rootConfig.companyId,
      appKey: rootConfig.appKey,
      appSecret: '',
      appType: 1,
      appChannel: '',
      oauthType: 2,
    };
    const url =
      'https://reg-saas.whweidu.com/v2/thirdparty/qq/login.do?' +
      qs.stringify(param);

    const browser = Util.getBrowserInfo();
    if (browser.name == 'chrome' && parseInt(browser.version) >= 80) {
      this.setState({
        qq_visible: false,
        qq_url: null,
      });
      const l = (window.screen.availWidth - 780) / 2;
      const t = (window.screen.availHeight - 549) / 2;
      window.open(
        url,
        '第三方登录',
        'height=549,innerHeight=549,width=780,innerWidth=780,top=' +
          t +
          ',left=' +
          l +
          ',status=no,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=0,titlebar=no'
      );
    } else {
      this.setState({
        qq_visible: true,
        qq_url: url,
      });
    }
  };

  // 微信 苇渡换绑手机号
  WXSecondaryModal = () => {
    const { base } = this.props;
    const { rootConfig } = base;
    const search = {
      v: rootConfig.version,
      ty: 'unbindphone',
      origin: 1,
    };
    // 换绑定手机号，修改 ty
    const callbackURI = `${window.location.protocol}//${window.location.host}/loginCallback.html?${qs.stringify(search)}`;
    const param = {
      display: '',
      callbackURI,
      companyId: rootConfig.companyId,
      appKey: rootConfig.appKey,
      appSecret: '',
      appType: 1,
      appChannel: '',
    };
    const url =
      'https://reg-saas.whweidu.com/v2/thirdparty/wechat/bind/login.do?';
    this.setState({
      wx_visible: true,
      wx_url: url + qs.stringify(param),
    });
  };

  // 关闭微信授权登录弹窗
  hideWXModal = (type = 'close') => {
    if (type === 'cancel') {
      this.props.loginSuccessPostMessage({ data: 'cancel' });
    }
    this.setState({ wx_visible: false, wx_url: null });
  };
  // 关闭QQ授权登录弹窗
  hideQQModal = (type = 'close') => {
    if (type === 'cancel') {
      this.props.loginSuccessPostMessage({ data: 'cancel' });
    }
    this.setState({ qq_visible: false, qq_url: null });
  };

  render() {
    const { wx_visible, wx_url, qq_visible, qq_url } = this.state;
    return (
      <Fragment>
        {/* 微信登录 */}
        <Modal
          open={wx_visible}
          title="身份验证"
          wrapClassName="daidai-modal-style has-top-border"
          centered={true}
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="500px"
          zIndex="1006"
          onCancel={() => this.hideWXModal('cancel')}
        >
          <div className="weixin-second-auth-plan">
            {wx_visible && wx_url ? (
              <Fragment>
                <p className="tip-text">请使用微信授权验证身份</p>
                <div className="iframe-border">
                  <iframe
                    src={wx_url}
                    title="微信登录"
                    scrolling="no"
                    width="300px"
                    height="300px"
                  />
                </div>
                <div className="desc-text">
                  <span className="icon-weixin" />
                  微信扫码授权验证身份
                </div>
              </Fragment>
            ) : null}
          </div>
        </Modal>
        {/* QQ 登录 */}
        <Modal
          open={qq_visible}
          wrapClassName="daidai-modal-style"
          centered={true}
          title="身份验证"
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="700px"
          zIndex="1006"
          onCancel={() => this.hideQQModal('cancel')}
        >
          <div className="qq-login-plan">
            {qq_visible ? (
              <iframe
                src={qq_url}
                title="QQ登录"
                scrolling="no"
                width="700px"
                height="400px"
              />
            ) : null}
          </div>
        </Modal>
      </Fragment>
    );
  }
}
